import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { PlusIcon } from '@heroicons/react/24/outline';
import { DoctorTrainingToolUploader } from '../components/DoctorTrainingToolUploader';
import { TrainingToolList } from '../components/TrainingToolList';

export default function DoctorTrainingTool() {
  const [isUploaderVisible, setUploaderVisibility] = useState(false);
  const { user } = useAuth();
  const [fetchResources, setFetchResources] = useState(false);

  return (
    <>
      <TrainingToolList fetchResources={fetchResources} />
      <div className="fixed bottom-6 right-6 z-50">
        <button
          type="button"
          className="rounded-full bg-secondary-cornflowerblue-600 p-2 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline 
        focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setUploaderVisibility(true)}
        >
          <PlusIcon aria-hidden="true" className="size-8" />
        </button>
        <DoctorTrainingToolUploader
          isUploaderVisible={isUploaderVisible}
          setUploaderVisibility={(val) => setUploaderVisibility(val)}
          token={user!.access_token}
          fetchTrigger={() => setFetchResources((prev) => !prev)}
        />
      </div>
    </>
  );
}
